import { Component } from '@opten/compiler/metadata/component';
import { Collapse } from './initializer';

@Component({ className: 'js-collapse' })
export class CollapseComponent {
	collapse: Collapse;
	constructor(private element: HTMLElement) {
		this.collapse = new Collapse(element, {});
	}
}
